import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12l6 -9l6 9l-6 9l-6 -9","key":"svg-0"}],["path",{"d":"M6 12l6 -3l6 3l-6 2l-6 -2","key":"svg-1"}]]

/**
 * IconCurrencyEthereum
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktZXRoZXJldW0iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgMTJsNiAtOWw2IDlsLTYgOWwtNiAtOSIgLz4KICA8cGF0aCBkPSJNNiAxMmw2IC0zbDYgM2wtNiAybC02IC0yIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-ethereum
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyEthereum = createReactComponent('outline', 'currency-ethereum', 'CurrencyEthereum', __iconNode);

export default IconCurrencyEthereum;